import "../Admin.css";
import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loading from "./loading.jsx";
import get from "../functions/get.js";
import Button from "./button.jsx";
import TestQuestion from "./test_questions.jsx";

const Test = () => {

    const location = useLocation();

    const [ currentExercise, setCurrentExercise ] = useState(null);
    const [ currentQuestion, setCurrentQuestion ] = useState(0);

    const params = new URLSearchParams(location.search);
    const ID = params.get("id");
    const savedQuestion = `exercise_progress_${ID}`;
    const pointsKey = `exercise_points_${ID}`;

    const startExercise = () => {
        localStorage.setItem(savedQuestion, 1);
        setCurrentQuestion(1);
    };

    const navigate = useNavigate();
    //Is just being passed down, so I can reset local states from child component
    const removeInfo = () => {
        localStorage.removeItem(pointsKey);
        setCurrentQuestion(0);
        navigate(-1);
    };

    const [ error, setError ] = useState("");

    const onChoiceRes = (res, data) => {

        if(!res) {
            setError("Server nicht erreichbar!");
            setLoading(false);
            return;
        };

        setLoading(false);

        if (res.status === 200) {

            const currentQuestion = localStorage.getItem(savedQuestion);
            
            if (currentQuestion) {
                const progress = parseInt(currentQuestion);
                setCurrentQuestion(progress);
            }

            if (Array.isArray(data)) {
                setCurrentExercise(data[0]);
            } else {
                setCurrentExercise(data);
            }
        } else {
            setError("Diese Übung existiert nicht mehr!")
        };

    };

    const [ exercises, setExercises ] = useState([]);
    const [ loading, setLoading ] = useState(false);

    const onRes = (res, data) => {

        if(!res) {
            setError("Server nicht erreichbar!");
            setLoading(false);
            return;
        };

        setLoading(false);
        if (res.status === 200) {
        setExercises(data);
        } else {
        setExercises([]);
        }
    };

    useEffect(() => {

        const params = new URLSearchParams(location.search);
        const id = params.get("id");

        setCurrentExercise(null);
        setCurrentQuestion(0);
        setError("");

        if(!id) {
            setLoading(true);
            
            const category = location.pathname.split("/");
            let url = "/get/exercises"
            if (category.length === 3) {
                url = `/get/exercises?category=${category[2]}`
            }
            get(url, onRes, onRes);
        } else {
            const numberID = Number(id);
            setLoading(true);
            get(`/get/exercises?id=${numberID}`, onChoiceRes, onChoiceRes);
        };
        
    }, [location.pathname]);

    if(error) {
        return (
            <div className="start-warning"><p>{error}</p></div>
        );
    };

    if (!location.pathname.includes("uebungen/uebung")) {
        return (

        <div className="test-div">
            <h2>ÜBUNG AUSWÄHLEN</h2>

            <div className="exercise-list">
                {loading ? (
                    <>
                                <div className="flex-row" style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}>

                                    <div className="skeleton skeleton-circle">

                                    </div>

                                    <div className="flex-col" style={{width: "calc(100% - 10px)"}}>

                                        <div className="skeleton skeleton-box">

                                        </div>

                                        <div className="skeleton skeleton-box  box2">

                                        </div>

                                    </div>
                                </div>

                                <div className="flex-row" style={{marginTop: "20px", justifyContent: "flex-start", width: "100%"}}>

                                    <div className="skeleton skeleton-circle">

                                    </div>

                                    <div className="flex-col" style={{width: "calc(100% - 10px)"}}>

                                        <div className="skeleton skeleton-box">

                                        </div>

                                        <div className="skeleton skeleton-box  box2">

                                        </div>

                                    </div>
                                </div>
                            </>
                ) : (
                exercises.map((e, idx) => {
                    let url;
                    let bg;

                    if (e.category === "Verben") {
                        url = "/images/verbs.png";
                        bg = "var(--yellow)";
                    } else if (e.category === "Nomen") {
                        url = "/images/nouns.png";
                        bg = "#2E8B57";
                    }

                    return (
                    <Link
                    to={`/uebungen/uebung?id=${e.id}`}
                    key={idx}
                    className="flex-row"
                    style={{justifyContent: "flex-start", marginTop: "30px"}}
                    >
                        <div className="skeleton-circle" style={{background: bg}}>
                        <img src={url} alt={`Logo für ${e.category}`} />
                        </div>

                        <div className="flex-col" style={{marginLeft: "10px"}}>
                        <div>{e.name}</div>
                        <div>
                            {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                className={star <= e.difficulty ? "star filled" : "star"}
                            >
                                ★
                            </span>
                            ))}
                        </div>
                        </div>
                    </Link>
                    );
                })
                )}
            </div>
            </div>
        );
    } else {

        return (
            <div className="exercise">
                {loading &&
                    <div className="exercise-loader flex-row">
                        <Loading />
                    </div>
                }

                {(!loading && currentExercise) &&
                    <>
                        {currentQuestion === 0 &&
                            <div>
                                <h2>{currentExercise.name}</h2>

                                <p>Diese Übung beinhaltet {currentExercise.questions.length} Fragen zum Thema {currentExercise.category}. Starte die Übung und beginne damit, die Fragen zu beantworten.</p>

                                <div onClick={startExercise}>
                                    <Button className="button-yellow" text="Starten" />
                                </div>
                            </div>
                        }

                        {currentQuestion !== 0 &&
                            <TestQuestion exercise={currentExercise} removeInfo={removeInfo} />
                        }
                    </>
                }
            </div>
        );

    };

}; export default Test;